module.exports = __webpack_public_path__ + "videos/relax-video.104d168.webm";